import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Restored from deployed site (leafsy.xyz)
const firebaseConfig = {
  apiKey: "AIzaSyClzhG5eNEZISle3un-7V_je9WTG4f-X0o",
  authDomain: "leafsy-aa976.firebaseapp.com",
  projectId: "leafsy-aa976",
  storageBucket: "leafsy-aa976.firebasestorage.app",
  messagingSenderId: "277947046492",
  appId: "1:277947046492:web:93e2fa80b791767b63e499"
};

// Try to use env vars if set
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
